import React from 'react'
import { Button } from '@s4l/ds'
import { IconClose } from '@s4l/icons/IconClose'
import styles from './styles.module.css'

interface IActionCloseProps {
  onClick: () => void
}

export const ActionClose = ({ onClick }: IActionCloseProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClick()
  }

  return (
    <div className={styles.container}>
      <Button
        variant="icon-flat"
        leadingIcon={<IconClose />}
        size="small"
        data-testid="close-button"
        onClick={handleClick}
        onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
        className={[
          'is-absolute',
          'top-neg8',
          'right-neg8',
          'tablet:top-neg16',
          'tablet:right-neg16',
        ]}
      />
    </div>
  )
}
ActionClose.displayName = 'ActionClose'
